(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header"] && !Shopify.designMode) return;
  try {
    (() => {
  const header = document.querySelector('.rlm-header');
  if (!header) return;
  let pending = false;
  const update = () => {
    header.classList.toggle('rlm-header-scrolled', window.scrollY > 24);
    pending = false;
  };
  window.addEventListener('scroll', () => {
    if (!pending) {
      pending = true;
      window.requestAnimationFrame(update);
    }
  }, { passive: true });
  update();
})();
  } catch(e) { console.error(e); }
})();

})();
